import {MutationTree} from "vuex";
import {RootState} from "@/store/index";
import {CognitoUser} from 'amazon-cognito-identity-js';
import {CognitoIdentityCredentials} from 'aws-sdk/global';
import {BucketDir, BucketFile} from "@/store/types";

export const SET_USER_MUTATION = 'SET_USER_MUTATION';
export const SET_LOGGED_MUTATION = 'SET_LOGGED_MUTATION';
export const SET_CREDENTIALS_MUTATION = 'SET_CREDENTIALS_MUTATION';
export const SET_FILES_MUTATION = 'SET_FILES_MUTATION';
export const CLEAR_STACK_MUTATION = 'CLEAR_STACK_MUTATION';
export const PUSH_NODE_MUTATION = 'PUSH_NODE_MUTATION';
export const POP_NODE_MUTATION = 'POP_NODE_MUTATION';

const mutations: MutationTree<RootState> = {
    [SET_USER_MUTATION]: (state: RootState, user: CognitoUser) => {
        state.user = user;
    },
    [SET_CREDENTIALS_MUTATION]: (state: RootState, credentials: CognitoIdentityCredentials) => {
        state.credentials = credentials;
    },
    [SET_LOGGED_MUTATION]: (state: RootState, logged: boolean) => {
        state.logged = logged;
    },
    [SET_FILES_MUTATION]: (state: RootState, files: BucketFile[]) => {
        state.files = files.filter(file => file.key.endsWith('.csv'));
    },
    [CLEAR_STACK_MUTATION]: (state: RootState) => {
        state.nodesStack = [];
    },
    [PUSH_NODE_MUTATION]: (state: RootState, node: BucketDir) => {
        state.nodesStack.push(node);
    },
    [POP_NODE_MUTATION]: (state: RootState) => {
        state.nodesStack.pop();
    },
};

export default mutations;
